var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from "aurelia-dependency-injection";
import { transient } from "aurelia-dependency-injection";
import { Router } from "aurelia-router";
import { DialogClientService } from "../../../../services/basics/dialog-client.service";
import { DialogServiceConstants } from "../../../../constants/basics/dialog.constants";
import * as Enumerable from "linq";
import { NotificationClientService, NotificationType } from "../../../../services/basics/notification-client.service";
var EventLogsNavbar = /** @class */ (function () {
    function EventLogsNavbar(router, notificationService, dialogClientService) {
        this.router = router;
        this.notificationService = notificationService;
        this.dialogClientService = dialogClientService;
    }
    EventLogsNavbar.prototype.activate = function (model) {
        this.model = model;
    };
    EventLogsNavbar.prototype.getSelectedIds = function () {
        var idsSelected = [];
        var rows = this.model.datagrid.getRowsCollection();
        rows.forEach(function (row) {
            if (row.item.select) {
                idsSelected.push(row.item.id);
            }
        });
        return idsSelected;
    };
    EventLogsNavbar.prototype.getFirstSelectedId = function () {
        var idSelected = null;
        var rows = this.model.datagrid.getRowsCollection();
        rows.forEach(function (row) {
            if (!idSelected) {
                if (row.item.select) {
                    idSelected = row.item.id;
                }
            }
        });
        return idSelected;
    };
    EventLogsNavbar.prototype.changeStatus = function () {
        var _this = this;
        if (!window["SystemJS"]) {
            require("" + "app/views/pages/queries/navbar/dialogs/change-logs-status-dialog");
        }
        var rows = this.model.datagrid.getRowsCollection().map(function (x) { return x.item; }).filter(function (x) { return x.select; });
        var allStatuses = Enumerable.from(rows).select(function (x) { return x.statusId; }).distinct().toArray();
        var allStatusReasons = Enumerable.from(rows).select(function (x) { return x.statusReasonId; }).distinct().toArray();
        if (allStatuses.length > 1 || allStatusReasons.length > 1) {
            this.notificationService.show("Error", "Status and Status Reason must be the same for all entities selected", NotificationType.Warning);
            return;
        }
        this.dialogClientService.show(DialogServiceConstants.URLs.ChangeLogsStatusDialog, {
            ids: this.getSelectedIds(),
            reload: function () { return _this.model.datagrid.reloadData(); },
            statusId: allStatuses[0],
            statusReasonId: allStatusReasons[0]
        });
    };
    EventLogsNavbar = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [Router,
            NotificationClientService,
            DialogClientService])
    ], EventLogsNavbar);
    return EventLogsNavbar;
}());
export { EventLogsNavbar };
